import { fontFamilies } from './fontFamilies';
import { fontSizes } from './fontSizes';
import { fontWeights } from './fontWeights';
import { levels } from './levels';
import { variants } from './variants';
export { fontFamily, monoFontFamily } from './fontFamilies';
/** ### Canvas Type Properties
 * [View Storybook Docs](https://workday.github.io/canvas-kit/?path=/story/tokens--type)
 *
 * ---
 * The type properties provide precise control and are only intended to be used when the type hierarchy tokens are not well-suited for the task.
 *
 * The properties are organized in three parts:
 *
 * - `fontFamilies`
 * - `fontSizes`
 * - `fontWeights`
 *
 * You can find more detailed information by inspecting individual properties.
 */
const properties = {
    fontFamilies,
    fontSizes,
    fontWeights,
};
/**
 * ### Canvas Type Tokens
 * [View Storybook Docs](https://workday.github.io/canvas-kit/?path=/story/tokens--type)
 *
 * ---
 * Type tokens are separated into three sections:
 *
 * - `levels` - provide higher-level styles for the Canvas type hierarchy: title, heading, body, and subtext
 * - `properties` - provide low-level type properties (font families, sizes, and weights)
 * - `variants` - provide modifiers for text styles (error, hint, and inverse)
 * */
export const type = {
    levels,
    properties,
    variants,
};
